export default "__VITE_ASSET__j0WPObkrdPgUHPI7wCPj4g__";